import axios from 'axios'
import {createStore} from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import {setAuthInHeader} from "@/api";
import shotUrlStore from "@/store/shotUrl";
import payStore from "@/store/pay";

export default createStore({
    state: {
        authInfo: {
            name : null,
            phoneNumber : null,
            token: null,
        }
    },
    mutations: {
        setAuthInfo(state, authInfo) {
            state.authInfo = authInfo
            setAuthInHeader(authInfo.token)
        },
        setName(state, name) {
            state.authInfo.name = name
        },
        removeAuthInfo(state) {
            state.authInfo = {
                name: null,
                orderPhoneNumber: null,
                token: null,
            }
            setAuthInHeader(null)
        }
    },
    getters: {

    },
    actions: {
        setName: ({commit}, data) => {
            console.log('commit setName', data)
            commit('setName', data);
        },
        login:({commit}, data) => {
            return new Promise((resove, reject) => {
                axios.post('/api/auth/login', data, {headers: {
                        "Content-Type": `application/json`,
                    }})
                    .then(result => {
                        console.log('login', result.data)

                        const response = result.data
                        if (response.code === "J0000") {
                            console.log(response)
                            console.log(response.data.phone_number)
                            console.log(response.data.token_type)
                            console.log(response.data.access_token)

                            const authInfo = {
                                name: null,
                                phoneNumber: response.data.phone_number,
                                token : response.data.token_type + " " + response.data.access_token,
                            };
                            console.log(authInfo)
                            commit('setAuthInfo', authInfo);
                            resove(authInfo)
                        } else {
                            alert('인증코드를 다시한번 확인해주세요.')
                            resove()
                        }
                    })
                    .catch(error => {
                        console.error(error)
                        alert('인증코드를 다시한번 확인해주세요.')
                        reject(error)
                    })
            })
        },
        logout: ({commit}) => {
            //cartStore.dispatch('removeCartInfo').then(r => r)
            shotUrlStore.dispatch('removeRouterInfo').then(r => r)
            payStore.dispatch('removePayInfo').then(r => r)
            commit('removeAuthInfo');
        }
    },
    modules: {},
    plugins: [
        createPersistedState()
    ]
})